import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
import axios from "axios";
import StandardButton from "@/components/buttons/StandardButton.vue";
import BigButton from "@/components/buttons/BigButton.vue";
import { alertError } from "@/util/dialog";
import WInput from "@/components/form/w-input.vue";
import AIStepsGenerator from "@/components/aiSpeachGenerator/AIStepsGenerator.vue";
import { waitingJob } from "@/util/job.utils";
import WSelect from "@/components/form/w-select.vue";
import WRadioGroup from "@/components/form/w-radio-group.vue";
import WLink from "@/components/wrappers/w-link.vue";
import WDialog from "@/components/wrappers/w-dialog.vue";
import WSlider from "@/components/wrappers/w-slider.vue";
import { Events } from "@/events/events";
import WToolTip from "@/components/tooltip/w-toolTip.vue";
import WTreeSelect from "@/components/form/w-tree-select.vue";
import { AutoTranscriptStatus } from "@/models/ai/aiSubChapter.model";
import { listOfLanguage } from "@/util/langUtils";
import { AiQuizQuestionsGenerationSource } from "@/models/ai/enum/AiQuizQuestionsGenerationSource.enum";
import AIQuizGenerationDocumentUpload from "@/components/aiQuizGenerator/AIQuizGenerationDocumentUpload.vue";
import AIQuizGenerationTextField from "@/components/aiQuizGenerator/AIQuizGenerationTextField.vue";
import AIQuizSubChapterSelect from "@/components/aiQuizGenerator/AIQuizSubChapterSelect.vue";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
let AIQuizGenerator = class AIQuizGenerator extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "chapterId", void 0);
    _defineProperty(this, "nbExistingQuestions", void 0);
    _defineProperty(this, "existingQuestions", []);
    _defineProperty(this, "progress", 0);
    _defineProperty(this, "generationInProgress", false);
    _defineProperty(this, "generationPopup", false);
    // Default to auto mode
    _defineProperty(this, "questionGenerationMode", "auto");
    _defineProperty(this, "AiQuizQuestionsGenerationSourceEnum", AiQuizQuestionsGenerationSource);
    _defineProperty(this, "questionGenerationSource", this.AiQuizQuestionsGenerationSourceEnum.SPEACH_CONTENT);
    _defineProperty(this, "nbCustomQuestions", 1);
    // Default to 1 question when in custom mode
    _defineProperty(this, "nbQuestionsToGenerate", 0);
    _defineProperty(this, "generatedQuiz", null);
    _defineProperty(this, "fullSpeach", null);
    _defineProperty(this, "refreshTimeOut", void 0);
    _defineProperty(this, "selectedChapters", []);
    _defineProperty(this, "textContent", '');
    _defineProperty(this, "promptHelper", '');
    _defineProperty(this, "customDocs", []);
    _defineProperty(this, "customDocsInError", []);
    _defineProperty(this, "selectedLang", "");
    _defineProperty(this, "maxNbQuestionsAllowed", 50);
  }
  // Options for radio group
  get questionModeOptions() {
    return [{
      value: "auto",
      label: this.$t("aiQuizGeneration.popup.autoMode")
    }, {
      value: "custom",
      label: this.$t("aiQuizGeneration.popup.customMode")
    }];
  }
  get isAutoTransriptFullyReady() {
    if (this.fullSpeach) {
      // Check all chapters and their subchapters
      for (const chapter of this.fullSpeach.chapters) {
        for (const subchapter of chapter.subchapters) {
          if (subchapter.autoTranscriptStatus === AutoTranscriptStatus.WAITING || subchapter.autoTranscriptStatus === AutoTranscriptStatus.ERROR) {
            return false;
          }
        }
      }
    }
    return true;
  }
  get marks() {
    return {
      1: '1',
      [this.customMaxNbQuestionsAllowed]: '' + this.customMaxNbQuestionsAllowed
    };
  }
  get listOfLanguage() {
    const listOfLangs = [{
      "value": "",
      "label": this.$t('aiSpeachGenerator.options.languages.placeholder')
    }];
    listOfLangs.push(...listOfLanguage(this.$t));
    return listOfLangs;
  }
  onTextContentChange(content) {
    this.textContent = content?.trim();
  }
  onPromptHelperChange(content) {
    this.promptHelper = content?.trim();
  }
  onGenerationByUploadDataChange(docs) {
    this.customDocs = docs;
  }
  loadExistingQuestions() {
    axios.get(`/recorder/aiQuizGenerator/questions/${this.chapterId}`).then(response => {
      this.existingQuestions = response.data;
    }).catch(error => {
      console.error("Error loading questions:", error);
    });
  }
  loadFullSpeach() {
    axios.get(`/recorder/aiQuizGenerator/speachFromChapter/${this.chapterId}`).then(response => {
      this.fullSpeach = response.data;
      if (!this.isAutoTransriptFullyReady) {
        clearTimeout(this.refreshTimeOut);
        this.refreshTimeOut = setTimeout(() => {
          this.loadFullSpeach();
        }, 5000);
      }
    }).catch(error => {
      console.error("Error loading speach:", error);
    });
  }
  /**
   * Retrieves the maximum number of questions allowed based on the remaining space
   * for questions, constrained by a predefined upper limit (20).
   *
   * @return {number} The number of questions that can still be added,
   * which is the minimum between 20 and the remaining available slots.
   */
  get customMaxNbQuestionsAllowed() {
    const remainingQuestions = this.maxNbQuestionsAllowed - this.nbExistingQuestions;
    return Math.max(0, Math.min(20, remainingQuestions));
  }
  get autoMaxNbQuestionsAllowed() {
    const remainingQuestions = this.maxNbQuestionsAllowed - this.nbExistingQuestions;
    return Math.max(0, remainingQuestions);
  }
  changeSelectedChapters(chapters) {
    this.selectedChapters = chapters;
  }
  openPopUp() {
    this.generationPopup = true;
    this.generationInProgress = false;
    this.loadExistingQuestions();
    this.loadFullSpeach();
  }
  closeGenerationPopup() {
    this.generationPopup = false;
    this.generationInProgress = false;
    clearTimeout(this.refreshTimeOut);
  }
  forceRegenerateTranscript(subchapterId) {
    axios.post('/recorder/aiQuizGenerator/forceTranscript/' + subchapterId).then(async resp => {
      this.fullSpeach = resp.data;
      this.loadFullSpeach();
    });
  }
  generateAIQuiz() {
    if (!this.quizGenerationInputIsValid()) {
      return;
    }
    this.generationInProgress = true;
    const formData = new FormData();
    formData.append('existingQuestions', JSON.stringify(this.existingQuestions));
    formData.append('nbQuestionsToGenerate', String(this.nbQuestionsToGenerate));
    formData.append('maxNbQuestionsAllowed', String(this.autoMaxNbQuestionsAllowed));
    let selectedChapters = [];
    if (this.questionGenerationSource === this.AiQuizQuestionsGenerationSourceEnum.SPEACH_CONTENT) {
      selectedChapters = this.selectedChapters;
    }
    if (this.questionGenerationSource === this.AiQuizQuestionsGenerationSourceEnum.TEXT_CONTENT) {
      formData.append('textContent', this.textContent);
    }
    if (this.questionGenerationSource === this.AiQuizQuestionsGenerationSourceEnum.DOCUMENT && this.customDocs?.length) {
      this.customDocs.forEach((file, index) => {
        formData.append(`documents`, file, file.name);
        formData.append(`docsNames`, file.name);
      });
    }
    if (this.promptHelper) {
      formData.append('promptHelper', this.promptHelper);
    }
    formData.append('selectedChapters', JSON.stringify(selectedChapters));
    formData.append('selectedLang', this.selectedLang);
    axios.post('/recorder/aiQuizGenerator/generate/' + this.chapterId, formData).then(async resp => {
      await this.waitStepGenerationProceed(resp.data);
    }).catch(err => {
      this.progress = -1;
      this.closeGenerationPopup();
      alertError(err);
    });
  }
  quizGenerationInputIsValid() {
    if (this.questionGenerationSource === this.AiQuizQuestionsGenerationSourceEnum.SPEACH_CONTENT && this.selectedChapters.length === 0) {
      return false;
    }
    if (this.questionGenerationSource === this.AiQuizQuestionsGenerationSourceEnum.TEXT_CONTENT && !this.textContent) {
      return false;
    }
    if (this.questionGenerationSource === this.AiQuizQuestionsGenerationSourceEnum.DOCUMENT && !this.customDocs?.length) {
      return false;
    }
    return true;
  }
  async waitStepGenerationProceed(jobID) {
    try {
      const data = await waitingJob(jobID);
      this.generatedQuiz = data;
      if (this.generatedQuiz.questions.length === 0) {
        this.generationInProgress = false;
        alertError(this.$t('aiQuizGeneration.popup.noQuestionGenerated'));
        return;
      }
      this.publishQuiz();
    } catch (e) {
      if (e?.errorData && e?.errorData?.docsInError?.length) {
        this.customDocsInError = e.errorData.docsInError;
        this.generationInProgress = false;
        clearTimeout(this.refreshTimeOut);
        alertError(this.$t('aiQuizGeneration.docsExtractionError'));
      } else {
        alertError(this.$t('aiContent.error'));
        this.closeGenerationPopup();
      }
    }
  }
  publishQuiz() {
    axios.post('/recorder/aiQuizGenerator/record/' + this.chapterId, this.generatedQuiz).then(async () => {
      WElMessage.showSuccessMessage(this.$t('aiQuizGeneration.quizGenerationSuccess'));
      this.closeGenerationPopup();
      const prevNbQuestions = this.existingQuestions.length;
      const totalCurrentNbQuestions = prevNbQuestions + (this.generatedQuiz?.questions?.length ?? 0);
      trig(Events.RAFRAICHIR_QUIZZ_NB_QUESTIONS_CHOISIES, {
        prevNbQuestions: prevNbQuestions,
        currentNbQuestions: totalCurrentNbQuestions
      });
      trig(Events.AFFICHER_EDITION_CHAPITRE, {
        id: this.chapterId
      });
    }).catch(e => {
      console.error(e);
      this.closeGenerationPopup();
      alertError(this.$t('aiContent.error'));
    });
  }
  onQuestionModeChange(mode) {
    // const mode=eventInpyt.target.value
    if (mode === 'auto') {
      // When switching to auto mode, we'll use 0 as the value for automatic generation
      this.nbQuestionsToGenerate = 0;
    } else if (mode === 'custom') {
      // When switching to custom mode, ensure we have at least 1 question
      this.nbQuestionsToGenerate = this.nbCustomQuestions;
    }
  }
  onNbCustomQuestionsChange(nb) {
    if (this.questionGenerationMode === 'custom') {
      this.nbQuestionsToGenerate = nb;
    }
  }
  onLanguageChange(lang) {
    this.selectedLang = lang;
  }
  beforeDestroy() {
    clearTimeout(this.refreshTimeOut);
  }
};
__decorate([Prop({
  required: true
})], AIQuizGenerator.prototype, "chapterId", void 0);
__decorate([Prop({
  required: true
})], AIQuizGenerator.prototype, "nbExistingQuestions", void 0);
AIQuizGenerator = __decorate([Component({
  components: {
    AIQuizSubChapterSelect,
    AIQuizGenerationTextField,
    AIQuizGenerationDocumentUpload,
    WTreeSelect,
    WToolTip,
    WSlider,
    WDialog,
    WLink,
    WSelect,
    WRadioGroup,
    AIStepsGenerator,
    WInput,
    BigButton,
    StandardButton,
    Icon
  }
})], AIQuizGenerator);
export default AIQuizGenerator;